import { TypeOfBillingSchemeEnum } from '../types/olo-api/olo-api.enums';

/** Completed Apple Pay / Google Pay payment method, or null. The `{}` reducer default is not a wallet payment. */
export function getValidDigitalPaymentInfo(digitalPaymentInfo: any) {
  if (
    digitalPaymentInfo &&
    typeof digitalPaymentInfo === 'object' &&
    digitalPaymentInfo.id != null &&
    String(digitalPaymentInfo.id).length > 0
  ) {
    return digitalPaymentInfo;
  }
  return null;
}

/** Checkout payment row for a completed wallet payment, or null when there is none. */
export function createDigitalWalletBillingScheme(
  digitalPaymentInfo: any,
  amount: number,
  localId: string,
) {
  const wallet = getValidDigitalPaymentInfo(digitalPaymentInfo);
  if (!wallet) {
    return null;
  }
  return {
    localId,
    selected: true,
    billingmethod: TypeOfBillingSchemeEnum.external,
    amount,
    tipportion: 0,
    expiryyear: wallet.card?.exp_year,
    expirymonth: wallet.card?.exp_month,
    zip: wallet.billing_details?.address?.postal_code,
    serviceName: wallet.serviceName,
  };
}

/** Olo accepts most saved-card orders without a CVV, so only send one when the guest entered it. */
export function getSavedCardCvvField(cvvToken?: string | null) {
  return cvvToken ? { cvv: cvvToken } : {};
}
